export function clamp(x, lo, hi) {
    return Math.max(lo, Math.min(hi, x));
}
export function mean(xs) {
    if (!xs.length)
        return 0;
    return xs.reduce((a, b) => a + b, 0) / xs.length;
}
export function stddev(xs) {
    if (xs.length < 2)
        return 0;
    const m = mean(xs);
    const v = mean(xs.map((x) => (x - m) * (x - m)));
    return Math.sqrt(v);
}
export function pct(a, b) {
    return b ? ((a - b) / b) * 100 : 0;
}
//# sourceMappingURL=util.js.map